<ng-template #template>
  <div class="d-flex justify-content-center">
    @if ((context$ | async); as context) {
      {{ 'label.autocomplete.ShowingNumOfTotal' | translate: {
      'found': context.shownCount,
      'total': context.totalCount || ('label.autocomplete.OfAll' | translate)
       } }}
    }
  </div>
</ng-template>
